import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../form_models/loanFormModel';

const { motivationAdditionalInformation } = loanFormModel.formField;

export class MotivationAdditionalInformationValidation
  implements ValidationSchema
{
  public name = motivationAdditionalInformation.name;
  public label = motivationAdditionalInformation.label;
  public type = 'string';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
}
export default new Validation(new MotivationAdditionalInformationValidation());
